







import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import EmployeeSearchItem from "@/components/molecules/EmployeeSearchItem.vue";
import { ISearchEmpInfo } from "@/types";

@Component({
  components: { EmployeeSearchItem },
})
export default class SearchEmp extends Vue {
  name: "SearchEmp";

  @Prop({ default: false })
  private hasError: boolean;

  private onClickSearchButton(empInfo: ISearchEmpInfo): void {
    this.$emit("on-click-search-button", empInfo);
  }
}
